import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';
import TermsDoc from '../../static/docs/Nia_Terms_of_Use.pdf';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  paper: {
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(10),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  content: {
    padding: theme.spacing(2),
  },
  niaLogoContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: theme.spacing(4),
  },
  link: {
    color: theme.palette.blue,
    textDecoration: 'none',
  },
  text: {
    paddingBottom: theme.spacing(),
  },
  spacer: {
    padding: theme.spacing(),
  },
});

const TermsPage = (props) => {
  const { classes } = props;
  return (
    <div className={classes.page}>
      <NavBar />
      <main className={classes.container}>
        <div className={classes.appBarSpacer} />
        <div className={classes.content}>
          <Typography className={classes.header} color="textSecondary" variant="h4">Terms of Use</Typography>
          <Paper className={classes.paper} elevation={1}>
            <iframe title="Terms of Use" src={TermsDoc + '#toolbar=0'} width="100%" height="500px">
            </iframe>
          </Paper>
        </div>
        <FooterSpacer />
      </main>
      <Footer />
    </div>
  );
};

TermsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TermsPage);
